import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription } from '@/common/ui/alert'

export default function BlacklistLegend() {
	return (
		<Alert className="mb-4 border-red-200 bg-red-50">
			<AlertDescription className="flex space-x-2 text-red-800">
				<AlertTriangle className="mt-1 h-4 w-4 text-red-600" />
				<span className="font-medium">หมายเหตุ:</span> แถวที่มี
				<span className="mx-1 inline-block rounded border-l-2 border-l-red-600 bg-red-100 px-2 py-0.5 text-xs font-medium text-red-900">
					พื้นหลังสีแดง
				</span>
				แสดงถึงผู้เล่นที่อยู่ในรายชื่อ Blacklist โปรดตรวจสอบก่อนดำเนินการ
			</AlertDescription>
		</Alert>
	)
}
